export const init = () => {
  if (tc_vars.page_name !== '/checkout/cart') return;

  /* ENHANCED E-COMMERCE - REMOVE FROM CART */

  const fwk = CUBE.Analytics;

  const trackerNameBasket = AnalyticsConstants.trackers.funnel.basket.name;
  const clickEventName = 'changeQuantityBtn';
  const changeEventName = 'changeQuantityInput';
  const removeEventName = 'removeProduct';

  const trackerNameSavelater =
    AnalyticsConstants.trackers.funnel.savelater.name;
  const addSaveLaterEventName = 'addToSaveLater';
  const removeSaveLaterEventName = 'removeFromSaveLater';

  const findProduct = '.faux-table-wrapper';

  if (!CUBE.Analytics.trackers.list[trackerNameBasket]) return;
  if (!CUBE.Analytics.trackers.list[trackerNameSavelater]) return;

  // Get events
  const eventClick =
    CUBE.Analytics.trackers.list[trackerNameBasket].events[clickEventName];
  const eventChange =
    CUBE.Analytics.trackers.list[trackerNameBasket].events[changeEventName];
  const eventRemove =
    CUBE.Analytics.trackers.list[trackerNameBasket].events[removeEventName];

  const eventAddSavelater =
    CUBE.Analytics.trackers.list[trackerNameSavelater].events[
      addSaveLaterEventName
    ];
  const eventRemoveSavelater =
    CUBE.Analytics.trackers.list[trackerNameSavelater].events[
      removeSaveLaterEventName
    ];

  const getVadaInfo = $product => {
    const $vada = $product.find('[data-universe]');
    return {
      family: $vada.data('family') || '',
      department: $vada.data('department') || '',
      subdepartment: $vada.data('subdepartment') || '',
      universe: $vada.data('universe') || '',
    };
  };

  /*
   * 	CHANGE QUANTITY (from Add / Remove btn)
   */
  eventClick.postAction($element => {
    const $product = $element.closest(findProduct);
    let refId = $product
      .find('[data-product-reference]')
      .data('product-reference');
    let model = fwk.utils.datalayer.getModel(refId);
    if (Object.keys(model).length === 0) {
      refId = $product.find('[product-id]').attr('product-id');
      model = fwk.utils.datalayer.getModel(refId);
    }

    model.quantity = 1;
    model.list = '/checkout/cart';
    if ($product.find('[model-id]').attr('model-id'))
      model.id = $product.find('[model-id]').attr('model-id');
    model.modelId = model.id;

    const currentProduct = fwk.getCurrentProducts($product.index() + 1);
    if (currentProduct) model.price = currentProduct.price;
    model.vada = getVadaInfo($product);

    if ($element.hasClass('icon-minus')) fwk.enhanced.sendRemoveToCart(model);
    // Remove quantity
    else fwk.enhanced.sendAddToCart(model); // Add quantity
  });

  /*
   * 	CHANGE QUANTITY (from input)
   */
  eventChange.postAction($element => {
    const $product = $element.closest(findProduct);
    let refId = $product
      .find('[data-product-reference]')
      .data('product-reference');
    let model = fwk.utils.datalayer.getModel(refId);
    if (Object.keys(model).length === 0) {
      refId = $product.find('[data-model-id]').data('model-id');
      model = fwk.utils.datalayer.getModel(refId);
    }

    // Compute quantity
    const oldVal = $element.data('quantity');
    const newVal = $element.val();
    const diff = parseInt(newVal, 10) - parseInt(oldVal, 10);

    model.quantity = Math.abs(diff);
    model.list = '/checkout/cart';
    model.id = $product.find('[data-model-id]').data('model-id');
    model.modelId = model.id;

    const currentProduct = fwk.getCurrentProducts($product.index() + 1);
    if (currentProduct) model.price = currentProduct.price;
    model.vada = getVadaInfo($product);

    if (diff < 0) fwk.enhanced.sendRemoveToCart(model);
    // Remove quantity
    else fwk.enhanced.sendAddToCart(model); // Add quantity
  });

  /*
   * 	REMOVE PRODUCT (from basket)
   */
  eventRemove.postAction($element => {
    const $product = $element.closest(findProduct);
    let refId = $product
      .find('[data-product-reference]')
      .data('product-reference');
    let model = fwk.utils.datalayer.getModel(refId);
    if (Object.keys(model).length === 0) {
      refId = $product.find('[model-id]').attr('model-id');
      model = fwk.utils.datalayer.getModel(refId);
    }

    if (Object.keys(model).length === 0) {
      model = fwk.utils.datalayer.getModelByIndex(
        parseInt($product.find('[index-item]').attr('index-item'), 10),
        'order_products'
      );
    } else if ($product.find('[data-model-id]').data('model-id')) {
      model.id = $product.find('[data-model-id]').data('model-id');
      model.modelId = model.id;
    }

    model.quantity = $product.find('[data-quantity]').data('quantity');
    model.list = '/checkout/cart';
    model.vada = getVadaInfo($product);

    const currentProduct = fwk.getCurrentProducts($product.index() + 1);
    if (currentProduct) model.price = currentProduct.price;

    fwk.enhanced.sendRemoveToCart(model); // Remove quantity
  });

  /*
   *  ADD TO BUY LATER - REMOVE PRODUCT (from cart)
   */
  eventAddSavelater.postAction($element => {
    const $product = $element.closest(findProduct);
    const modelId = $product.find('[data-product-id]').attr('data-product-id');

    let model = fwk.utils.datalayer.getModel(modelId);
    if (Object.keys(model).length === 0) {
      const refId = $product.find('[data-model-id]').data('model-id');
      model = fwk.utils.datalayer.getModel(refId);
    }
    if (Object.keys(model).length === 0) {
      model = fwk.utils.datalayer.getModelByIndex(
        parseInt($product.find('[index-item]').attr('index-item'), 10),
        'order_products'
      );
    } else {
      model.id = $product.find('[data-model-id]').data('model-id');
      model.modelId = model.id;
    }

    model.quantity = $product.find('[data-quantity]').data('quantity');
    model.list = '/checkout/cart';
    model.vada = getVadaInfo($product);

    // Remove quantity
    fwk.enhanced.sendRemoveToCart(model);
  });

  /*
   *  REMOVE FROM BUY LATER - ADD PRODUCT (to cart)
   */
  eventRemoveSavelater.postAction($element => {
    const $product = $element.closest(findProduct);
    const modelId = $product.find('[data-productid]').attr('data-productid');
    let model = fwk.utils.datalayer.getModel(modelId);
    if (Object.keys(model).length === 0) {
      let refId = $product.find('[data-model-id]').data('model-id');
      if (!refId) refId = $product.find('[data-modelid]').data('modelid');
      model = fwk.utils.datalayer.getModel(refId);
    }

    model.id = $product.find('[data-modelid]').data('modelid');
    model.modelId = model.id;
    model.vada = getVadaInfo($product);
    model.quantity = 1;
    model.list = '/checkout/cart';
    fwk.enhanced.setModelVada(model); // set 'model.category' with 'model.vada{}' info (if any)
    fwk.enhanced.set({
      id: model.id,
      position: model.position,
      list: model.list,
      variant: model.variant,
      category: model.category,
      label: model.name,
      brand: model.brand,
    });
    fwk.enhanced.sendAddToCart(model); // Remove quantity
  });
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-5-remove-from-cart.js